module.exports = __webpack_public_path__ + "bbc539ed4e4aa38e233bbe8ac26c43a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-flowers.png
// module id = 2879
// module chunks = 0